import { LitElement, html } from 'lit';
import styles from './fit-content-filter.css';

/**
 * Element that allows us to filter content with button clicks.
 *
 * @element fit-content-filter
 */
class FitContentFilter extends LitElement {
  static get is() { return 'fit-content-filter'; }

  static get styles() { return styles; }

  render() {
    return html`
      <div id="row-category">
        <slot name="category-buttons"></slot>
      </div>
      
      <div id="row-subcategory">
        <slot name="subcategory-buttons"></slot>
      </div>
      
      <div id="content-items">
        <slot name="content-items"></slot>
      </div>
    `;
  }

  static get properties() {
    return {
      category: {
        type: String,
        attribute: 'category',
      },
      subcategory: {
        type: String,
        attribute: 'subcategory',
      },
    };
  }

  constructor(props) {
    super(props);
    this.category = 'all';
    this.subcategory = '';
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this._handleButtonClick);
  }

  addButtonClass(buttonEl, classToAdd) {
    buttonEl.classList.add(classToAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this._handleButtonClick);
  }

  _filterCategory() {
    const allSubcats = this.querySelectorAll('.content-filter__subcats');
    allSubcats.forEach((subcat) => {
      this.category === 'all' ? subcat.style.display = 'inline-block' : subCat.style.display = 'none';
      if (subCat.getAttribute('parentcategory') === currentCat) {
        subCat.style.display = 'inline-block';
      }
    });
    this._filterContent();
  }

  _filterContent() {
    const contentItems = this.querySelectorAll('.content-filter__item');
    contentItems.forEach((contentItem) => {
      if (this.category === 'all') {
        contentItem.style.display = 'block';
        if (!contentItem.getAttribute('content-category').match(this.subcategory)) {
          contentItem.style.display = 'none';
        }
      } else if (contentItem.getAttribute('content-category').match(this.category)) {
        contentItem.style.display = 'block';
        if (!contentItem.getAttribute('content-category').match(this.subcategory)) {
          contentItem.style.display = 'none';
        }
      } else {
        contentItem.style.display = 'none';
      }
    });
  }

  _handleButtonClick(event) {
    const clickedButton = event.target;
    if (clickedButton.classList.contains('content-filter__cat')) {
      this.category = clickedButton.getAttribute('category');
      this.subcategory = '';
    }
    if (clickedButton.classList.contains('content-filter__subcat')) {
      this.subcategory = clickedButton.getAttribute('subcategory');
    }
    this._setActiveButtons();
  }

  _setActiveButtons() {
    const allCatButtons = this.querySelectorAll('.content-filter__cat');
    const allSubcatButtons = this.querySelectorAll('.content-filter__subcat');
    const newActiveCatButton = this.querySelector(`[category="${this.category}"]`);
    allCatButtons.forEach((catButton) => {
      this.removeButtonClass(catButton, 'active');
    });
    allSubcatButtons.forEach((subcatButton) => {
      this.removeButtonClass(subcatButton, 'active');
    });
    this.addButtonClass(newActiveCatButton, 'active');
    if (this.subcategory !== '') {
      const newActiveSubatButton = this.querySelector(`[category="${this.subcategory}"]`);
      this.addButtonClass(newActiveSubatButton, 'active');
    }
  }

  removeButtonClass(buttonEl, classToRemove) {
    buttonEl.classList.remove(classToRemove);
  }

  updated(changedProperties) {
    if (changedProperties.has('category')) {
      this._filterCategory();
    }
    if (changedProperties.has('subcategory')) {
      this._filterCategory();
    }
  }
}

customElements.define(FitContentFilter.is, FitContentFilter);
